import { useEffect, useRef, useState } from "react"
import { HexAlphaColorPicker, HexColorInput } from "react-colorful"

const MIN_ALPHA = 0x01

export const ColorPicker = ({
    selectedColor,
    setSelectedColor,
    debounceMs = 50,
}: {
    selectedColor: string
    setSelectedColor: (color: string) => void
    debounceMs?: number
}) => {
    const [color, setColor] = useState(selectedColor)
    const debounceTimeout = useRef<ReturnType<typeof setTimeout> | null>(null)

    useEffect(() => {
        setColor(selectedColor)
    }, [selectedColor])

    const updateColor = (color: string) => {
        if (color.length === 9) {
            const alpha = parseInt(color.substring(7, 9), 16)
            if (alpha < MIN_ALPHA) {
                color = color.substring(0, 7) + "01"
            }
        }

        if (debounceTimeout.current) clearTimeout(debounceTimeout.current)

        debounceTimeout.current = setTimeout(() => setSelectedColor(color), debounceMs)
    }

    return (
        <div className="flex flex-col !rounded-none transform z-10">
            <section className="react-colorful__last-control">
                <HexAlphaColorPicker
                    color={color}
                    onChange={updateColor}
                    className="rounded-b-none react-colorful__last-control"
                />
            </section>

            <HexColorInput
                color={color}
                onChange={updateColor}
                prefixed
                placeholder="Add a hex code"
                alpha
                className="bg-[#303030] rounded-b-lg text-white py-1 text-center focus:outline-none"
            />
        </div>
    )
}
